var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12Z",
    fill: "#FF8833"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_42_2119",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12Z",
    fill: "#FF8833"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_42_2119)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 4.5C-2.91828 4.5 -6.5 8.08172 -6.5 12.5C-6.5 16.9183 -2.91828 20.5 1.5 20.5C5.91828 20.5 9.5 16.9183 9.5 12.5C9.5 8.08172 5.91828 4.5 1.5 4.5ZM-7.5 12.5C-7.5 7.52944 -3.47056 3.5 1.5 3.5C6.47056 3.5 10.5 7.52944 10.5 12.5C10.5 17.4706 6.47056 21.5 1.5 21.5C-3.47056 21.5 -7.5 17.4706 -7.5 12.5Z",
    fill: "#8D33FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 4.5C18.0817 4.5 14.5 8.08172 14.5 12.5C14.5 16.9183 18.0817 20.5 22.5 20.5C26.9183 20.5 30.5 16.9183 30.5 12.5C30.5 8.08172 26.9183 4.5 22.5 4.5ZM13.5 12.5C13.5 7.52944 17.5294 3.5 22.5 3.5C27.4706 3.5 31.5 7.52944 31.5 12.5C31.5 17.4706 27.4706 21.5 22.5 21.5C17.5294 21.5 13.5 17.4706 13.5 12.5Z",
    fill: "#8D33FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 24.25V0.5H12.5V24.25H11.5Z",
    fill: "#8D33FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12L23.75 12L23.75 13L-4.37114e-08 13L0 12Z",
    fill: "#8D33FF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall);
export default __webpack_public_path__ + "static/media/ball.50ebb741eead4a7ec55669646890bfe0.svg";
export { ForwardRef as ReactComponent };